import { Link } from 'react-router-dom';
import { Caption1, Card, CardHeader, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { ArrowRightRegular, GridRegular } from '@fluentui/react-icons';
import { SQUARE_CARD_HEIGHT } from '@shared/components/Square.constants';
import { useSquareCardStyles } from '@shared/components/Square.styles';
import { TERMINOLOGY } from '@shared/i18n';

const useStyles = makeStyles({
  card: {
    height: SQUARE_CARD_HEIGHT,
    padding: tokens.spacingHorizontalL,
  },
  tile: {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: '20px',
  },
  footer: {
    position: 'absolute',
    right: tokens.spacingHorizontalL,
    bottom: tokens.spacingVerticalL,
    left: tokens.spacingHorizontalL,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: tokens.colorNeutralForeground2,
  },
});

type TProps = {
  numProducts: number;
};

const ShowAllProductsCard = ({ numProducts }: TProps) => {
  const classes = useStyles();
  const squareClasses = useSquareCardStyles();

  return (
    <Link to="/products" className="h-fit w-fit">
      <Card className={mergeClasses(squareClasses.card, classes.card)}>
        <CardHeader
          image={
            <span className={classes.tile}>
              <GridRegular />
            </span>
          }
          header={<span className={squareClasses.title}>Show all {TERMINOLOGY.product.lowerPlural}</span>}
        />
        <div className={classes.footer}>
          <Caption1>
            {numProducts} {TERMINOLOGY.product.lowerPlural}
          </Caption1>
          <ArrowRightRegular fontSize={20} />
        </div>
      </Card>
    </Link>
  );
};

export default ShowAllProductsCard;
